import React, { useState, useMemo } from 'react';
import SearchConditionStyled from './SearchConditionStyled';
import { useForm, Controller } from 'react-hook-form';
import {
  Box,
  FormControl,
  Button,
  useTheme,
  FormHelperText,
} from '@material-ui/core';
import ReplayIcon from '@material-ui/icons/Replay';
import SearchIcon from '@material-ui/icons/Search';
// import AutoComplateML from '@/components/AutoComplateML';
import DateRangePickerML from '@/components/DateRangePickerML';
import { useIntl } from 'umi';
import dayjs from 'dayjs';

// 限制查询范围：6 个月内的天数（按当前日期向后加 6 个月，再 diff 出实际天数）
const SIX_MONTHS_DAYS = dayjs(
  dayjs().add(6, 'month').format('YYYY-MM-DD'),
).diff(dayjs().format('YYYY-MM-DD'), 'day');

const SearchCondition = (props) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const { query } = props;
  const { handleSearch, restClick, searchRef } = props;
  const {
    signUpDateEnd,
    signUpDateStart,
    registerStore: RegisterStore,
  } = query;
  const theme = useTheme();
  const { handleSubmit, control, setValue, getValues } = useForm({
    defaultValues: {
      date: { startDate: signUpDateStart, endDate: signUpDateEnd },
    },
  });

  //控制日期控件的重置
  const [isResetDefalut, setIsResetDefalut] = useState(false);

  // 状态保持时注册门店和服务门店
  // eslint-disable-next-line no-unused-vars
  const defaultRegisterStore = useMemo(() => {
    let RegisterStoreArray = [];
    if (RegisterStore) {
      RegisterStoreArray = RegisterStore.split('-');
    }
    return RegisterStoreArray;
  }, [RegisterStore]);

  const [rsValue, setRsValue] = useState([]);

  //点击重置
  const resetData = () => {
    const resetSearch = {
      date: {
        endDate: dayjs().format('YYYY-MM-DD'),
        startDate: dayjs().format('YYYY-MM-DD'),
      },
    };
    setValue('date', resetSearch);
    // reset(resetSearch);
    setIsResetDefalut(true);
    // setIsReset(true);
    setRsValue([]);
    const propsResetSearch = {
      registerStore: '',
      signUpDateEnd: dayjs().format('YYYY-MM-DD'),
      signUpDateStart: dayjs().format('YYYY-MM-DD'),
    };
    restClick && restClick(propsResetSearch);
  };

  //查询
  const handleSubmitSuccess = (submitData) => {
    const registerStore = rsValue?.join('-');
    const propsSubmitData = {
      ...submitData,
      registerStore,
      signUpDateEnd: submitData.date?.endDate ?? signUpDateEnd,
      signUpDateStart: submitData.date?.startDate ?? signUpDateStart,
      isSearch: true,
    };
    delete propsSubmitData.date;
    handleSearch && handleSearch(propsSubmitData);
  };

  // 日期为空校验
  const isDataValid =
    getValues('date')?.startDate === null ||
    getValues('date')?.endDate === null;

  // 日期超过6个月校验
  const dateDiffValid =
    dayjs(getValues('date')?.endDate).diff(
      dayjs(getValues('date')?.startDate),
      'day',
    ) > SIX_MONTHS_DAYS;

  return (
    <SearchConditionStyled theme={theme}>
      <form onSubmit={handleSubmit(handleSubmitSuccess)}>
        <div className="search-condition-wrap">
          <div className="card-content-wrap">
            {/* <FormControl variant="standard" className="single-select">
              <AutoComplateML
                label={formatMessage({ id: 'cm.analysis.n01.chb01' })}
                defaultValue={defaultRegisterStore}
                selectedId={rsValue}
                setSelectedId={setRsValue}
              />
            </FormControl> */}
            <FormControl variant="standard" className="single-select">
              <Controller
                render={(rp) => (
                  <DateRangePickerML
                    afterDays={SIX_MONTHS_DAYS}
                    startText={formatMessage({ id: 'cm.analysis.n01.rdo02' })}
                    endText={formatMessage({ id: 'cm.analysis.n01.rdo04' })}
                    defaultStartDate={
                      signUpDateStart === undefined
                        ? dayjs().format('YYYY-MM-DD')
                        : signUpDateStart
                    }
                    defaultEndDate={
                      signUpDateEnd === undefined
                        ? dayjs().format('YYYY-MM-DD')
                        : signUpDateEnd
                    }
                    rp={rp}
                    onChange={({ startDate, endDate }) => {
                      handleSearch({
                        signUpDateStart: startDate,
                        signUpDateEnd: endDate,
                        isSearch: 'false',
                      });
                      // setIsReset(false);
                      setIsResetDefalut(false);
                    }}
                    name="custom-form-submit-name"
                    // isReset={isReset}
                    isResetDefalut={isResetDefalut}
                  />
                )}
                name="date"
                control={control}
                rules={{
                  // required: true,
                  validate: () => {
                    const status = !(
                      getValues('date').startDate === null ||
                      getValues('date').endDate === null
                    );
                    const dateStatus = dayjs(getValues('date')?.endDate).diff(
                      dayjs(getValues('date')?.startDate),
                      'day',
                    );
                    return dateStatus <= SIX_MONTHS_DAYS && status;
                  },
                }}
              />
              <FormHelperText error={Boolean(isDataValid)}>
                {isDataValid && '日期不得为空'}
              </FormHelperText>
              <FormHelperText error={Boolean(dateDiffValid)}>
                {dateDiffValid && '日期间隔不得大于6个月'}
              </FormHelperText>
            </FormControl>
          </div>
          {/* 按钮 */}
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              type="reset"
              className="reset"
              onClick={() => resetData()}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {/* 重置 */}
              {formatMessage({ id: 'cm.member.n01.btn10' })}
            </Button>
            <Button
              data-log={JSON.stringify({
                oid: 'btn_offline_store_customer_analysis_details_search',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              ref={searchRef}
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {/* 查询 */}
              {formatMessage({ id: 'cm.analysis.n01.btn06' })}
            </Button>
          </Box>
        </div>
      </form>
    </SearchConditionStyled>
  );
};

export default SearchCondition;
